import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from "react-query";
import { HardAgeVerificationPopup } from "@jti/ui/components/HardAgeVerificationPopup";
const queryClient = new QueryClient();
export const QrAgeVerificationContainer = (props) => (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(HardAgeVerificationPopup, { ...props }) }));
//# sourceMappingURL=QrAgeVerificationContainer.js.map